import template from './send-report-modal.html';
import SendReportController from './send-report-modal.controller';
import BaseViewController from '../../common/services/base-view-controller';


class ReportController extends  BaseViewController {

    constructor($scope, $state,  LoadedModel, $uibModal) {
        super($scope, $state, LoadedModel);
        this._$uibModal = $uibModal;
        const viewKey = this.model.selectedReportView.value || this.feasibilityViewKey;
        this.loadViewOrUpdate(viewKey);
        this.priceUnit = this.model.priceUnit.value;
        this.takeAllSnapshots();
        this.model.restoreUserDetails();
    }

    deleteSnapshot(imageToDelete) {
        this.model.snapshots = this.model.snapshots.filter(function(snapshot) {
            return  snapshot.index !== imageToDelete.index;
        });
    }

    takeAllSnapshots() {
        const mapper = ['thinningView', 'formabilityView', 'blankView',  'nestView'];
        if(!this.model.snapshots.length) {
            mapper.forEach((type) => {
                this.model.takeSnapshot(type, true);
            });
        }
    }

    openModal() {
        this._$uibModal.open({
            size: 'sm',
            animation: false,
            template: template,
            controllerAs: '$ctrl',
            controller: SendReportController,
        });
    }

}

ReportController.$inject = ['$scope',  '$state' , 'LoadedModel', '$uibModal'];

export default ReportController;



// WEBPACK FOOTER //
// ./client/app/components/report/report.controller.js